import React, { useEffect, useState } from 'react'
import Collapsible from 'react-collapsible'

Array.prototype.inArray = function (comparer) {
  for (var i = 0; i < this.length; i++) {
    if (comparer(this[i])) return true
  }
  return false
}

Array.prototype.pushIfNotExist = function (element, comparer) {
  if (!this.inArray(comparer)) {
    this.push(element)
  }
}

const FilterSideBar = ({
  products,
  collections,
  onFilterByCollection,
  onFilterByVariant,
  isCollectionSpecificPage,
  filter,
}) => {
  const [sizes, setSizes] = useState()
  const [colors, setColors] = useState()
  const [filterOption, setFilterOption] = useState({
    collectionTitle: filter.collectionTitle,
    size: filter.size,
    color: filter.collectionTitle,
  })
  const [showFilterBy, setShowFilterBy] = useState()

  useEffect(() => {
    setFilterOption({
      ...filterOption,
      collectionTitle: filter.collectionTitle,
      size: filter.size,
      color: filter.color,
    })
  }, [filter])

  useEffect(() => {
    const sizesArr = []
    const colorsArr = []
    Promise.all(
      products.map((product) => {
        product.options.map((option) => {
          if (option.name === 'Size') {
            option.values.map((x) => {
              sizesArr.pushIfNotExist(x.value, function (e) {
                return e === x.value
              })
            })
          }
        })

        product.tags.map((tag) => {
          if (tag.value.includes('color: ')) {
            const color = tag.value.replace('color: ', '')
            colorsArr.pushIfNotExist(color, function (e) {
              return e === color
            })
          }
        })
      })
    )
    setSizes(sizesArr)
    setColors(colorsArr)
  }, [])

  const onViewCollection = (collection) => {
    onFilterByCollection(collection, collection.title)
  }

  const onFilter = (option, value) => {
    onFilterByVariant(option, value)
  }

  const renderCollections = () => {
    return (
      <ul>
        <li>
          <a
            onClick={() => onViewCollection({ title: 'All' })}
            className={filterOption.collectionTitle === 'All' ? 'active' : ''}
          >
            All
          </a>
        </li>

        {collections.map((collection, i) => (
          <li key={i}>
            <a
              onClick={() => onViewCollection(collection)}
              className={
                filterOption.collectionTitle === collection.title
                  ? 'active'
                  : ''
              }
            >
              {collection.title}
            </a>
          </li>
        ))}
      </ul>
    )
  }

  const renderSizes = () => {
    return (
      <ul>
        {sizes.length > 0 ? (
          sizes.map((size, i) => (
            <li key={i}>
              <a
                onClick={() => onFilter('size', size)}
                className={filterOption.size === size ? 'active' : ''}
              >
                {size}
              </a>
            </li>
          ))
        ) : (
          <li>
            <p>None</p>
          </li>
        )}
      </ul>
    )
  }

  const renderColors = () => {
    return colors.length > 0 ? (
      <ul className='color-options'>
        {colors.map((color, i) => (
          <li key={i}>
            <a
              className={`${
                filterOption.color === color ? 'active' : ''
              } color-option`}
              style={{ backgroundColor: color }}
              onClick={() => onFilter('color', color)}
            ></a>
          </li>
        ))}
      </ul>
    ) : (
      <ul>
        <li>
          <p>None</p>
        </li>
      </ul>
    )
  }

  const onClickFilterBy = (option) => {
    if (showFilterBy === option) {
      setShowFilterBy(null)
    } else {
      setShowFilterBy(option)
    }
  }

  return (
    <div className='filter-products'>
      <div className='mobile-filter show-mobile'>
        <div className='filter-top'>
          {!isCollectionSpecificPage && collections && (
            <div
              className='filter-by'
              onClick={() => onClickFilterBy('categories')}
            >
              <p>Categories {showFilterBy === 'categories' ? '-' : '+'}</p>
            </div>
          )}

          <div className='filter-by' onClick={() => onClickFilterBy('size')}>
            <p>Size {showFilterBy === 'size' ? '-' : '+'}</p>
          </div>
          <div className='filter-by' onClick={() => onClickFilterBy('color')}>
            <p>Color {showFilterBy === 'color' ? '-' : '+'}</p>
          </div>
        </div>
        {showFilterBy && (
          <div className='filter-bottom'>
            {!isCollectionSpecificPage &&
              showFilterBy === 'categories' &&
              collections &&
              renderCollections()}
            {showFilterBy === 'size' && sizes && renderSizes()}
            {showFilterBy === 'color' && colors && renderColors()}
          </div>
        )}
      </div>
      {!isCollectionSpecificPage && collections && (
        <div className='filter-section hide-mobile'>
          <p className='title'>Browse by:</p>
          <div className='filter-by'>{renderCollections()}</div>
        </div>
      )}

      <div className='filter-section hide-mobile'>
        <p className='title'>Filter by:</p>
        <div className='filter-by'>
          <Collapsible trigger='Size' open>
            {sizes ? renderSizes() : <p>No option available</p>}
          </Collapsible>
        </div>
        <div className='filter-by hide-mobile'>
          <Collapsible trigger='Color' open>
            {colors ? renderColors() : <p>No option available</p>}
          </Collapsible>
        </div>
      </div>
    </div>
  )
}

export default FilterSideBar
